// @flow

import type {Effect} from '../../types'

import {
  take,
  put,
} from 'redux-saga/effects'
import {
  actions as routerActions,
} from 'redux-router5'
import {mapActions} from '../actions'
import {placeActions} from '../../place/actions'

export function* onClickPlaceEffect(): Effect {
  while (true) {
    const {payload: {place}} = yield take(mapActions.onClickPlace.id)
    yield put(placeActions.setPlace(null))
    yield put(routerActions.navigateTo('place-detail', {'place': place._links.self})) 
  }
}
